<script lang="ts">
  import { flip } from 'svelte/animate';

  import Tile from './board/Tile.svelte';
  import DimensionsContext from './utils/DimensionsContext.svelte';

  const logo = [
    { letter: 'G', highlighted: 'blue' as const },
    { letter: 'J', highlighted: 'green' as const },
  ];
</script>

<DimensionsContext width={10} height={10}>
  <div class="title">
    {#each logo as { letter, highlighted }, i (i)}
      <div class="subtitle" animate:flip={{ duration: 1000 }}>
        <Tile
          selected
          {highlighted}
          tile={{ id: letter, letter }}
          size="logo"
        />
      </div>
    {/each}
  </div>
</DimensionsContext>

<style lang="scss">
  @use '~/theme/include-media' as *;
  .title {
    visibility: visible;
    position: relative;
    width: 2.5rem;
    height: 2.5rem;
    margin-right: 0.2rem;
  }
  .subtitle {
    cursor: pointer !important;
    width: 2em;
    height: 2em;
    font-size: 0.8rem;
    position: absolute;
    &:first-of-type {
      z-index: 2;
      transform: rotate(-4deg);
      top: 0;
    }
    &:last-of-type {
      z-index: 1;
      bottom: 0;
      right: 0;
      transform: rotate(4deg);
    }
  }
</style>
